<template>
  <div class="helpCenter">
    <div v-if="searchFlag == false">
      <div class="helpCenter_top">
        <div class="helpCenter_box">   
          <div class="helpCenter_top_title">
              Hellow!!  How can we help you?
          </div>
          <div class="helpCenter_top_search">
            <div class="helpCenter_top_left">
              <img src="../assets/helpCenter_search.svg" alt="">
              <input class="helpCenter_top_search_text" placeholder="Search for a key word…" @input="searchArticle(searchText, 1)" v-model="searchText" @keydown.enter="searchArticle(searchText, 2)" @focus="searchShow(1)" @blur="searchShow(2)"/>
            </div>
            <div  class="search_data" v-if='searchListShow'>
              <div class="search_data_list" v-for="(item,index) in input_data" :key="index" @click="()=>{searchText = item.post_title; changeRoute(item, 4)}">{{item.post_title}}</div>
              <div v-if="input_data.length === 0" class="search_data_list">No results found</div>
            </div>
            <div class="helpCenter_top_search_button" @click="searchArticle(searchText, 2)">
                Search
            </div>
          </div>
          <div class="helpCenter_top_popular">
            <div class="helpCenter_top_popular_text">
              Popualr searches:
            </div>
            <div class="helpCenter_top_popular_box">
              <div v-for="(item, index) in popular_search" :key="index" 
              class="helpCenter_top_popular_box_item" @click="changeRoute(item, 1)">
                  {{item.name}}
              </div>
            </div>
          </div>
          <img src="../assets/help1.svg" alt="" v-if="ismobile" class="helpCenter_top_img">
        </div>
      </div>
      
      <div class="helpCenter_directions">
          <div class="helpCenter_directions_box">
              <div class="helpCenter_directions_title" @click="changeRoute(true, 3)">Directions</div>
              <div class="helpCenter_directions_content">
                  <div class="helpCenter_directions_content_box" @click="changeArticleRoute('Get Started')">
                      <img src="../assets/helpCenter_start.svg" alt="">
                      <div class="helpCenter_directions_content_box_title">Get Started</div>
                      <div class="helpCenter_directions_content_box_subtitle">All info you need to get up and running with Saledish.</div>
                  </div>
                  <div class="helpCenter_directions_content_box" @click="changeArticleRoute('Pricing %26amp; Plans')">
                      <img src="../assets/helpCenter_pricing.svg" alt="">
                      <div class="helpCenter_directions_content_box_title">Pricing & Plans</div>
                      <div class="helpCenter_directions_content_box_subtitle">Learn more about our pricing & plans.</div>
                  </div>
                  <div class="helpCenter_directions_content_box" @click="changeArticleRoute('Miscellaneous')">
                      <img src="../assets/helpCenter_miscellaneous.svg" alt="">
                      <div class="helpCenter_directions_content_box_title">Miscellaneous</div>
                      <div class="helpCenter_directions_content_box_subtitle">Other knowledge you may need to know.</div>
                  </div>
              </div>
          </div>
      </div>
        
      <div class="helpCenter_apps">
          <div class="helpCenter_apps_box">
              <div class="helpCenter_apps_title" @click="changeRoute(true, 3)">Apps</div>
              <div class="helpCenter_apps_tab">
                  <div v-for="(item,index) in tab" :key="index" class="helpCenter_apps_tab_box" @click="changeTab(index)">
                      <div :class="tabid==index ? 'helpCenter_apps_tab_box_text' : 'helpCenter_apps_tab_box_text_hide'">{{item}}</div>
                      <div :class="tabid==index ? 'helpCenter_apps_tab_box_line' : 'helpCenter_apps_tab_box_line_hide'"></div>
                  </div>
              </div>
              <div class="helpCenter_apps_line"></div>
              <div v-for="(item,index) in tab" v-show="index==tabid" :key="index" >
                  <div v-if="index==0" class="helpCenter_apps_content">
                      <div v-for="(app,count) in allapp_data" :key="count" 
                      :class="count % 3 == 0 ? 'helpCenter_apps_content_box':'helpCenter_apps_content_box helpCenter_apps_content_boxr'"
                      @click="changeArticleRoute(app.app_name)">
                          <img :src="app.img">
                          <div class="helpCenter_apps_content_name">
                              {{app.app_name}}
                          </div>
                          <div class="helpCenter_apps_content_content">
                              {{app.app_content}}
                          </div>
                      </div>
                  </div>
                  <div v-else class="helpCenter_apps_content">
                      <div v-for="(app,count) in category_data[index-1].data" :key="count" 
                      :class="count % 3 == 0 ? 'helpCenter_apps_content_box':'helpCenter_apps_content_box helpCenter_apps_content_boxr'"
                      @click="changeArticleRoute(app.app_name)">
                          <img :src="app.img">
                          <div class="helpCenter_apps_content_name">
                              {{app.app_name}}
                          </div>
                          <div class="helpCenter_apps_content_content">
                              {{app.app_content}}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import Input from './input/input.vue';

export default {
  name: 'HelpCenter',
  components: {
    Header,
    Footer,
    Input,
  },
  data(){
      return{
        input_data: [],
        popular_search: [],
        tab: ["All apps"],
        allapp_data: [],
        category_data: [],
        article_data: [
            {
                title: "Free shopping bar",
                content: "Progress content ( When visitors add products to cart, but free shipping amount has something todo"
            },{
                title: "Free shopping bar",
                content: "Progress content ( When visitors add products to cart, but free shipping amount has something to do to product"
            }
        ],
        directions_data: [
            {
                name: "Get started",
                data: "",
            },
            {
                name: "Pricing & Plans",
                data: "",
            },
            {
                name: "Miscellaneous",
                data: "",
            },
            {
                name: "General",
                data: "",
            }
        ],
        mostPopular_data: ["How to set Recently viewed","How to use Quickly checkout","How to set Terms of service confirmation","Detailed paid plan"],
        tabid: 0,
        searchFlag: false,         //搜索标签
        searchContent: 'free',
        popularFlag: false,
        categoryFlag: true,
        searchText: "",
        searchListShow: false,
        searchTermStr: "",
        searchIdStr: "",
        countPageContent: {},
        searchBetweenTimer: null,
        hotArticle: [],
        firstNode: -1,
        secondNode:-1,
        thirdNode: -1,
        forthNode: -1,
        articleId:[-1,-1,-1,-1],
        articleContent:'',         //文章内容
        articleName: '',           //文章标题
        articleNumber: 1,
        ismobile:false,
      };
  },
  methods:{
    changeTab(index){
      this.tabid = index;
    },
    getData() {
      this.$axios.get(`https://gateway.salesdish.com/shopify-service/app-tools/pass/apps/1100`).then((res)=>{
        for(let i = 1; i < res.data.list.length; i++){
          if(res.data.list[i].enabled == true){
            var obj ={
              name:'',
              data:[]
            }
            obj.name=res.data.list[i].name
            this.tab.push(res.data.list[i].name)
            res.data.list[i].children.forEach(value=>{
              var item = new Object
              item.app_name = value.name
              this.searchTermStr = this.searchTermStr + value.name  + ','
              item.app_content = value.introduce
              if(value.enabled == true || value.id === 36427){
                try {
                  item.img = require(`../assets/antools_app_icon${value.id}.svg`)
                  obj.data.push(item)
                  this.allapp_data.push(item)
                } catch (error) {
                  console.log("ID:" + value.id, value.name);
                  item.img = require(`../assets/antools_app_icon_default.svg`)
                  obj.data.push(item)
                  this.allapp_data.push(item)
                }
              }
            })
            this.category_data.push(obj)
          }
        }
        this.getTermId()
      })
    },
    // 展示搜索列表
    searchShow(type) {
      if (type === 1) {
        if (this.input_data.length > 0) {
          this.searchListShow = true;
        } else {
          this.searchListShow = false;
        }
      } else if (type === 2) {
        setTimeout(()=>{
          this.searchListShow = false;
          this.input_data = [];
        }, 300)
      }
    },
    // 文章计数
    getAndSaveCount(name, pId, tName, tId, route) {
      // 接口获取计数文章
      this.$axios.get(`/posts/1`).then((res)=>{
        let str = res.data.post.post_content
        str = str.replace(/[\r\n]/g, ""); 
        let pRe = new RegExp(/<p>{.*}<\/p>/gi) // 匹配包含对象的<p>标签
        str = str.match(pRe);
        // console.log(str[0].slice(3,-4));
        this.countPageContent = JSON.parse(str[0].slice(3,-4))
        this.countPageContent[name] ? this.countPageContent[name].count += 1 : this.countPageContent[name] = {name: name, count: 1, route:route, trem_name: tName, termId: tId, pageId: pId}
        // console.log(this.countPageContent)

        // 修改文章
        // this.countPageContent={}
        this.$axios.put(`/posts/1`, { post_content: `<p>${JSON.stringify(this.countPageContent)}</p>`}).then((res)=>{
        //   console.log(res.data)
        })
      })
    },
    // 获取 termID 
    getTermId() {
      this.$axios.get(`/term?names=${this.searchTermStr+"Get started,Pricing %26amp; Plans,Miscellaneous,General"}`).then((res)=>{
        res.data.terms.forEach(item => {
          this.searchIdStr += item.term_id + ",";
        });
        this.searchIdStr = this.searchIdStr.slice(0, -1)
      })
    },
    // 获取 热门文章
    getHotArticle() {
      // 接口获取计数文章
      this.$axios.get(`/posts/1`).then((res) => {
        let str = res.data.post.post_content
        str = str.replace(/[\r\n]/g, ""); 
        let pRe = new RegExp(/<p>{.*}<\/p>/gi) // 匹配包含对象的<p>标签
        str = str.match(pRe);
        let dataObj = JSON.parse(str[0].slice(3,-4));
        // console.log(dataObj)
        let dataArr = []
        dataArr.push(Object.keys(dataObj).map((key)=>{
          return dataObj[key]
        }))
        // console.log(dataArr)
        this.hotArticle = dataArr[0].sort((a, b)=>{
          return b.count - a.count
        })
        this.popular_search = this.hotArticle.slice(0, 5)
        // console.log(this.hotArticle)
        // console.log(this.popular_search)
      })
    },
    // 搜索
    searchArticle(sText, type) {
      if (type === 1) {
        // console.log(sText)
        // 过滤
        this.input_data = this.input_data.filter((item)=>{
          if (this.input_data.length > 0) {
            this.searchShow(1);
            return item.post_title.indexOf(sText) !== -1
          } else {

          }
        })
        
        clearTimeout(this.searchBetweenTimer)
        // 查询
        this.searchBetweenTimer = setTimeout(()=>{
          this.$axios.get(`/posts?term_ids=${this.searchIdStr}&name=${sText}&size=100&need_term_name=true`).then((res) => {
            this.input_data = res.data.posts
            if (this.input_data.length > 0) {
              this.searchShow(1);
            }
          })
        },200)
      } else if (type === 2) {
        if (sText !== "") {
          this.changeRoute(sText, 2)
        }
      }
    },

    // 切换路由
    changeRoute (val, type) {
      if (type === 1) {
        this.getAndSaveCount(val.name)
        this.$router.push({
          path: 'help/detail?p=' + val.pageId
        }).catch(err => {
          // console.log('e',err)
        })
      } else if (type === 2) {
        this.$router.push({
          path: 'help/detail?t=' + val
        }).catch(err => {
          // console.log('e',err)
        })
      } else if (type === 3) {
        this.$router.push({
          path: 'help/detail?most=' + val
        }).catch(err => {
          // console.log('e',err)
        })
      } else if (type === 4) {
        this.getAndSaveCount(val.post_title)
        this.$router.push({
          path: 'help/detail?p=' + val.id
        }).catch(err => {
          // console.log('e',err)
        })
      }
    },
    changeArticleRoute(tName){
        this.$axios.get(`/term?names=${tName}`).then((res) => {
            let tId = res.data.terms[0].term_id;
                this.$axios.get(`/posts?term_ids=${tId}&need_term_name=true`).then((res) => {
                this.changeRoute(res.data.posts[0],4)
                })
        })
    },
  },
  created(){
    if(document.body.offsetWidth>767){
      this.ismobile=false
    }else{
      this.ismobile=true
    }
    this.getData()
    this.getHotArticle()
  }
}
</script>

<style scoped>
#input_data {
  width: 500px;
}
.helpCenter{
    background: #F9FBFF;
}
.helpCenter_top{
    background: url(../assets/helpCenter_background.svg);
    height: 483px;
    background-size: cover;
    background-position: center;
}
.helpCenter_box{
    width: 1200px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.helpCenter_top_title{
    font-size: 40px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #0C0546;
    line-height: 40px;
    text-align: center;
    padding-top: 125px;
    padding-bottom: 63px;
}
.helpCenter_top_search{
    width: fit-content;
    display: flex;
    justify-content: center;
    margin-bottom: 35px;
    /* padding-right: 16px; */
    position: relative;
}
.helpCenter_top_search img{
    position: relative;
    left:41px;
}
.helpCenter_top_search_text{
    width: 746px;
    height: 50px;
    padding-left: 46px;
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    
    line-height: 19px;
    text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
    border: 2px solid #FFFFFF;
}
.helpCenter_top_search_text:focus {
  border: 2px solid #01C4C7;
  border-radius: 4px 0 0 4px;
}
.helpCenter_top_search_text::placeholder {
  color: rgba(0, 0, 0, 0.25);
}

.search_data {
  width: 744px;
  max-height: 400px;
  background: #FFFFFF;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
              0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  position: absolute;
  left: 20px;
  top: 50px;
  overflow-y: auto;
  padding: 4px 0;
}
.search_data_list {
  /* height: 40px; */
  background: #FFFFFF;
  font-size: 14px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8C8C8C;
  /* line-height: 40px; */
  cursor: pointer;
  padding: 16px 12px;
}
.search_data_list:hover, .search_data_list:focus{
  background: #01C4C70c;
  color: #00B9BC;
}
.helpCenter_top_search_button{
    width: 120px;
    height: 50px;
    background: linear-gradient(14deg, #01B4C2 0%, #00D8CE 100%);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    font-size: 18px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 50px;
    text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
    text-align: center;
    cursor: pointer;
}
.helpCenter_top_popular{
    max-width: 850px;
    display: flex;
    justify-content: center;
}
.helpCenter_top_popular_text{
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #0C0546;
    line-height: 19px;
    padding-top: 5px;
    padding-right: 11px;
    white-space: nowrap;
}
.helpCenter_top_popular_box{
    display: flex;
    flex-wrap: wrap;
}
.helpCenter_top_popular_box_item{
    height: 32px;
    border-radius: 2px;
    border: 1px solid #120C4B;
    font-size: 14px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #0C0546;
    margin-left: 10px;
    padding: 6px 14px;
    text-align: center;
    white-space: nowrap;
    margin-bottom: 10px;
    cursor: pointer;
}
.helpCenter_directions_box{
    width: 1200px;
    margin: auto;
}
.helpCenter_directions_title{
    font-size: 32px;
    font-family: Helvetica-Medium, Helvetica;
    font-weight: 600;
    color: #222536;
    line-height: 40px;
    margin-top: 60px;
    margin-bottom: 45px;
    cursor: pointer;
    display: inline-block;
}
.helpCenter_directions_content{
    display: flex;
    justify-content: space-between;
}
.helpCenter_directions_content_box{
    width: 374px;
    height: 284px;
    background: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 60px;
    cursor: pointer;
}
.helpCenter_directions_content_box:hover{
    box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
      0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
}
.helpCenter_directions_content_box img{
    margin: 37px 0 18px;
}
.helpCenter_directions_content_box_title{
    font-size: 20px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 28px;
    margin-bottom: 16px;
}
.helpCenter_directions_content_box_subtitle{
    width: 342px;
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #8D919B;
    line-height: 24px;
    text-align: center;
}
.helpCenter_apps_box{
    width: 1200px;
    margin: auto;
}
.helpCenter_apps_title{
    font-size: 32px;
    font-family: Helvetica-Medium, Helvetica;
    font-weight: 600;
    color: #222536;
    line-height: 40px;
    margin-bottom: 44px;
    cursor: pointer;
    display: inline-block;
}
.helpCenter_apps_tab{
    display: flex;
    justify-content: space-around;
}
.helpCenter_apps_tab_box{
    cursor: pointer;
}
.helpCenter_apps_tab_box_text{
    height: 40px;
    font-size: 16px;
    font-family: Helvetica;
    color: #01C4C7;
    line-height: 40px;
    margin-bottom: 7px;
}
.helpCenter_apps_tab_box_text_hide{
    height: 40px;
    font-size: 16px;
    font-family: Helvetica;
    color: #222536;
    line-height: 40px;
    margin-bottom: 7px;
}
.helpCenter_apps_tab_box_line{
    height: 4px;
    background: #01C4C7;
    border-radius: 3px;
}
.helpCenter_apps_tab_box_line_hide{
    height: 4px;
    background: #F9FBFF;
    border-radius: 3px;
}
.helpCenter_apps_line{
    width: 1200px;
    height: 1px;
    border: 1px solid rgba(151, 151, 151, 0.3);
}
.helpCenter_apps_content{
    display: flex;
    flex-wrap: wrap;
    padding-top: 15px;
    padding-bottom: 90px;
}
.helpCenter_apps_content_box{
    width: 386px;
    height: 325px;
    background: #FFFFFF;
    box-shadow: 0px 5px 4px 0px rgba(167, 167, 167, 0.08);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    cursor: pointer;
}
.helpCenter_apps_content_box:hover{
     box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
      0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
}
.helpCenter_apps_content_boxr{
    margin-left: 21px;
}
.helpCenter_apps_content_box img{
    margin-top: 30px;
}
.helpCenter_apps_content_name{
    height: 28px;
    font-size: 20px;
    font-family: Helvetica-Medium, Helvetica;
    font-weight: 600;
    color: #222536;
    line-height: 28px;
    text-align: center;
    margin-top: 18px;
}
.helpCenter_apps_content_content{
    width: 352px;
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #8D919B;
    line-height: 24px;
    text-align: center;
    margin-top: 18px;
}
.helpCenter_search{
    background: #F9FBFF;
}
.helpCenter_search_box{
    width: 1200px;
    margin: auto;
    display: flex;
}
.helpCenter_search_left{
    padding-top: 60px;
}
.helpCenter_search_left_top_input{
    width: 354px;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
    line-height: 19px;
    text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
    text-transform: capitalize;
    padding-left: 15px;
}
.helpCenter_search_left_top img{
    position: relative;
    right:31px;
}
.helpCenter_search_left_category{
    margin-top: 48px;
}
.helpCenter_search_left_category_title{
    font-size: 20px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #222536;
    line-height: 24px;
}
.helpCenter_search_left_category_list{
    margin-top: 40px;
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #222536;
    /* line-height: 19px; */
}
.helpCenter_search_left_category_list img{
    margin-right: 12px;
}
.helpCenter_search_left_category_ul{
    margin-bottom: 18px;
    /* cursor: pointer; */
}
.helpCenter_search_left_category_ul div{
    /* height: 36px; */
    /* margin-bottom: 18px; */
    cursor: pointer;
}
.helpCenter_search_left_category_first{
    margin-left: 14px;
}
.helpCenter_search_left_category_first_hide{
    display: none;
}
.helpCenter_search_left_category_li{
    /* height: 36px; */
    padding-top: 18px;
    /* padding-bottom: 9px; */
    /* cursor: pointer; */
}
.helpCenter_search_left_category_li_second{
    /* height: 36px; */
    line-height: 36px;
    margin-top: 9px;
}
.helpCenter_search_left_category_choose{
    width: 310px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #01C4C7;
    background-color: rgba(1, 196, 199, 0.05);
    /* background-color: #F9FBFF; */
    border-radius: 5px;
    /* margin-top: -9px; */
    /* margin-bottom: -9px; */
    
}
.helpCenter_search_left_category_nochoose{
    width: 310px;
    height: 36px;
    line-height: 36px;
}
/* .helpCenter_search_left_category_choose span{ */
    /* width: 200px; */
/* } */
.helpCenter_search_left_category_second{
    margin-left: 14px;
}
.helpCenter_search_left_category_second_hide{
    display: none;
}
.helpCenter_search_left_category_third{
    margin-left: 14px;
}
.helpCenter_search_left_category_third_hide{
    display: none;
}
.helpCenter_search_left_category_forth{
    width: 296px;
    height: 35px;
    line-height: 35px;
    padding-left: 28px;
    margin-top: 9px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.helpCenter_search_left_category_forth_choose{
    font-size: 16px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #01C4C7;
    background-color: rgba(1, 196, 199, 0.05);
    border-radius: 5px;

}
.helpCenter_search_right{
    padding-top: 30px;
    margin-left: 25px;
}
.helpCenter_search_right_top{
    font-size: 14px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #222536;
    line-height: 22px;
    display: flex;
    margin-top: 30px;
}
.helpCenter_search_right_top_text{
    padding-right: 8px;
}
.helpCenter_search_right_top img{
    padding-right: 8px;
}
.helpCenter_search_right_article{
    width: 800px;
    min-height: 750px;
    background: #FFFFFF;
    box-shadow: 0px 5px 4px 0px rgba(167, 167, 167, 0.08);
    border-radius: 10px;
    margin-top: 30px;
    margin-bottom: 100px;
}
.helpCenter_search_right_article_top{
    display: flex;
    justify-content: space-between;
    padding-top: 45px;
    padding-left: 30px;
}
.helpCenter_search_right_article_title{
    font-size: 32px;
    font-family: Helvetica-Medium, Helvetica;
    font-weight: 600;
    color: #222536;
    line-height: 40px;
    
}
.helpCenter_search_right_article_title span{
    color: #01C4C7;
}
.helpCenter_search_right_article_count{
    font-size: 20px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: normal;
    color: #8C8C8C;
    line-height: 40px;
    padding-right: 30px;
}
.helpCenter_search_right_article_count span{
    font-size: 22px;
    font-weight: bold;
    color: #222536;
}
.helpCenter_search_right_article_content{
    margin-top: 45px;
    margin-left: 30px;
}
.helpCenter_search_right_article_content_line{
    width: 747px;
    height: 2px;
    border: 1px solid #CBCBCB;
    margin-top: 25px;
    margin-bottom: 25px;
}
.helpCenter_search_right_article_content_title{
    font-size: 24px;
    font-family: Helvetica-Bold, Helvetica;
    color: #222536;
    line-height: 28px;
    margin-bottom: 15px;
}
.helpCenter_search_right_article_content_content{
    font-size: 20px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #8590AC;
    line-height: 27px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
@media (max-width:767px){
  #input_data {
    width: 500px;
  }
  .helpCenter{
      background: #F9FBFF;
  }
  .helpCenter_top{
      background: none;
      height: auto;
      padding-top: 1.05rem;
  }
  .helpCenter_box{
      width: 100%;
      padding:1.14rem .48rem .63rem ;
      background: rgba(1,196,199,0.06);
  }
  .helpCenter_top_title{
      font-size: .44rem;
      font-weight: 700;
      line-height: initial;
      padding: 0;
  }
  .helpCenter_top_search{
      margin: .5rem auto .25rem;
      width: 100%;
      align-items: center;
  }
  .helpCenter_top_search img{
      position: absolute;
      top: .42rem;
      left: .25rem;
      width: .16rem;
      height: .16rem;
  }
  .helpCenter_top_search_text{
      width: 100%;
      height: .96rem;
      padding-left: .46rem;
      font-size: .28rem;
      line-height: initial;
      text-shadow:none;
      border: .02rem solid #FFFFFF;
  }
  .helpCenter_top_search_text:focus {
    border: .02rem solid #01C4C7;
    border-radius: .08rem 0 0 .08rem;
  }
  .helpCenter_top_left{
    width: 75%;
  }
  .search_data {
    width: 75%;
    max-height: 4rem;
    box-shadow: 0px .06rem .16rem 0px rgba(0, 0, 0, 0.08),
                0px .03rem .06rem -.04rem rgba(0, 0, 0, 0.12);
    left: 0;
    top: .96rem;
    padding: .04rem 0;
  }
  .search_data_list {
    /* height: 40px; */
    font-size: .14rem;
    padding: .16rem .12rem;
  }

  .helpCenter_top_search_button{
      width: 1.6rem;
      height: .96rem;
      background: #01C4C7;
      box-shadow: none;
      font-size: .28rem;
      font-weight: 700;
      line-height: 0.96rem;
      border-radius: .08rem;
      position: relative;
      left:-.03rem
  }
  .helpCenter_top_popular_text{
      font-size: .18rem;
      line-height: initial;
      padding-top: 0;
      padding-right: .15rem;
  }
  .helpCenter_top_popular_box_item{
      height: .32rem;
      border-radius: .02rem;
      font-size: .14rem;
      margin-left: .1rem;
      padding: .08rem .16rem;
      margin-bottom: .14rem;
      display: flex;
      align-items: center;
  }
  .helpCenter_top_img{
    width: 100%;
    margin-top:.25rem
  }
  .helpCenter_directions_box{
      width: 100%;
      padding:.6rem .48rem  .32rem;
  }
  .helpCenter_directions_title{
      font-size: .32rem;
      font-weight: 400;
      line-height: .4rem;
      margin-top: 0;
      margin-bottom: .32rem;
  }
  .helpCenter_directions_content{
      display: block;
  }
  .helpCenter_directions_content_box{
      width: 100%;
      height: 4.82rem;
      box-shadow: 0px 0 .24rem 0px rgba(168,168,168,0.15);
      margin-bottom: .28rem;
      padding: 0 .48rem;
  }
  .helpCenter_directions_content_box:hover{
      box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
        0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
  }
  .helpCenter_directions_content_box img{
      margin: .58rem 0 .55rem;
      width: 1.95rem;
      height: 1.85rem;
  }
  .helpCenter_directions_content_box_title{
      font-size: .36rem;
      font-weight: 700;
      line-height: .28rem;
      margin-bottom: .2rem;
  }
  .helpCenter_directions_content_box_subtitle{
      width: 100%;
      font-size: .28rem;
      line-height: .38rem;
  }
  .helpCenter_apps_box{
      width: 100%;
      padding:0 .48rem .72rem
  }
  .helpCenter_apps_title{
      font-size: .32rem;
      font-weight: 400;
      line-height: .4rem;
      margin-top: 0;
      margin-bottom: .32rem;
  }
  .helpCenter_apps_tab{
      overflow: auto;
      display: -webkit-box;
  }
  .helpCenter_apps_tab_box+.helpCenter_apps_tab_box{
      margin-left: .48rem;
  }
  .helpCenter_apps_tab_box_text{
      opacity: .6;
      height: auto;
      font-size: .28rem;
      color: #01C4C7;
      line-height: initial;
      margin-bottom: .13rem;
  }
  .helpCenter_apps_tab_box_text_hide{
       opacity: .6;
      height: auto;
      font-size: .28rem;
      color: #222536;
      line-height: initial;
      margin-bottom: .13rem;
  }
  .helpCenter_apps_tab_box_line{
      height: .04rem;
      border-radius: .04rem;
  }
  .helpCenter_apps_tab_box_line_hide{
      height: .04rem;
      border-radius: .04rem;
  }
  .helpCenter_apps_line{
      width: 100%;
      height: 1px;
      border: 1px solid rgba(151, 151, 151, 0.3);
  }
  .helpCenter_apps_content{
      padding-top: .32rem;
      padding-bottom: 0;
  }
  .helpCenter_apps_content_box{
       width: 100%;
      height: 4.82rem;
      box-shadow: 0px 0 .24rem 0px rgba(168,168,168,0.15);
      margin-bottom: .28rem;
      margin-top: 0;
      padding: 0 .48rem;
  }
  .helpCenter_apps_content_box:hover{
      box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
        0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
  }
  .helpCenter_apps_content_boxr{
      margin-left: 0;
  }
  .helpCenter_apps_content_box img{
       margin: .58rem 0 .55rem;
      width: 1.95rem;
      height: 1.85rem;
  }
  .helpCenter_apps_content_name{
     font-size: .36rem;
      font-weight: 700;
      line-height: .28rem;
      margin-bottom: .2rem;
      margin-top: 0;
  }
  .helpCenter_apps_content_content{
    width: 100%;
    font-size: .28rem;
    line-height: .38rem;
    margin-top: 0;
  }
  .helpCenter_search{
      background: #F9FBFF;
  }
  .helpCenter_search_box{
      width: 1200px;
      margin: auto;
      display: flex;
  }
  .helpCenter_search_left{
      padding-top: 60px;
  }
  .helpCenter_search_left_top_input{
      width: 354px;
      height: 50px;
      background: #FFFFFF;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      font-size: 16px;
      font-family: Helvetica-Regular, Helvetica;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.25);
      line-height: 19px;
      text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
      text-transform: capitalize;
      padding-left: 15px;
  }
  .helpCenter_search_left_top img{
      position: relative;
      right:31px;
  }
  .helpCenter_search_left_category{
      margin-top: 48px;
  }
  .helpCenter_search_left_category_title{
      font-size: 20px;
      font-family: Helvetica-Regular, Helvetica;
      font-weight: 400;
      color: #222536;
      line-height: 24px;
  }
  .helpCenter_search_left_category_list{
      margin-top: 40px;
      font-size: 16px;
      font-family: Helvetica-Regular, Helvetica;
      font-weight: 400;
      color: #222536;
      /* line-height: 19px; */
  }
  .helpCenter_search_left_category_list img{
      margin-right: 12px;
  }
  .helpCenter_search_left_category_ul{
      margin-bottom: 18px;
      /* cursor: pointer; */
  }
  .helpCenter_search_left_category_ul div{
      /* height: 36px; */
      /* margin-bottom: 18px; */
      cursor: pointer;
  }
  .helpCenter_search_left_category_first{
      margin-left: 14px;
  }
  .helpCenter_search_left_category_first_hide{
      display: none;
  }
  .helpCenter_search_left_category_li{
      /* height: 36px; */
      padding-top: 18px;
      /* padding-bottom: 9px; */
      /* cursor: pointer; */
  }
  .helpCenter_search_left_category_li_second{
      /* height: 36px; */
      line-height: 36px;
      margin-top: 9px;
  }
  .helpCenter_search_left_category_choose{
      width: 310px;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-family: Helvetica-Regular, Helvetica;
      font-weight: 400;
      color: #01C4C7;
      background-color: rgba(1, 196, 199, 0.05);
      /* background-color: #F9FBFF; */
      border-radius: 5px;
      /* margin-top: -9px; */
      /* margin-bottom: -9px; */
      
  }
  .helpCenter_search_left_category_nochoose{
      width: 310px;
      height: 36px;
      line-height: 36px;
  }
  /* .helpCenter_search_left_category_choose span{ */
      /* width: 200px; */
  /* } */
  .helpCenter_search_left_category_second{
      margin-left: 14px;
  }
  .helpCenter_search_left_category_second_hide{
      display: none;
  }
  .helpCenter_search_left_category_third{
      margin-left: 14px;
  }
  .helpCenter_search_left_category_third_hide{
      display: none;
  }
  .helpCenter_search_left_category_forth{
      width: 296px;
      height: 35px;
      line-height: 35px;
      padding-left: 28px;
      margin-top: 9px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }
  .helpCenter_search_left_category_forth_choose{
      font-size: 16px;
      font-family: Helvetica-Regular, Helvetica;
      font-weight: 400;
      color: #01C4C7;
      background-color: rgba(1, 196, 199, 0.05);
      border-radius: 5px;

  }
  .helpCenter_search_right{
      padding-top: 30px;
      margin-left: 25px;
  }
  .helpCenter_search_right_top{
      font-size: 14px;
      font-family: Helvetica-Regular, Helvetica;
      font-weight: 400;
      color: #222536;
      line-height: 22px;
      display: flex;
      margin-top: 30px;
  }
  .helpCenter_search_right_top_text{
      padding-right: 8px;
  }
  .helpCenter_search_right_top img{
      padding-right: 8px;
  }
  .helpCenter_search_right_article{
      width: 800px;
      min-height: 750px;
      background: #FFFFFF;
      box-shadow: 0px 5px 4px 0px rgba(167, 167, 167, 0.08);
      border-radius: 10px;
      margin-top: 30px;
      margin-bottom: 100px;
  }
  .helpCenter_search_right_article_top{
      display: flex;
      justify-content: space-between;
      padding-top: 45px;
      padding-left: 30px;
  }
  .helpCenter_search_right_article_title{
      font-size: 32px;
      font-family: Helvetica-Medium, Helvetica;
      font-weight: 600;
      color: #222536;
      line-height: 40px;
      
  }
  .helpCenter_search_right_article_title span{
      color: #01C4C7;
  }
  .helpCenter_search_right_article_count{
      font-size: 20px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: normal;
      color: #8C8C8C;
      line-height: 40px;
      padding-right: 30px;
  }
  .helpCenter_search_right_article_count span{
      font-size: 22px;
      font-weight: bold;
      color: #222536;
  }
  .helpCenter_search_right_article_content{
      margin-top: 45px;
      margin-left: 30px;
  }
  .helpCenter_search_right_article_content_line{
      width: 747px;
      height: 2px;
      border: 1px solid #CBCBCB;
      margin-top: 25px;
      margin-bottom: 25px;
  }
  .helpCenter_search_right_article_content_title{
      font-size: 24px;
      font-family: Helvetica-Bold, Helvetica;
      color: #222536;
      line-height: 28px;
      margin-bottom: 15px;
  }
  .helpCenter_search_right_article_content_content{
      font-size: 20px;
      font-family: Helvetica-Regular, Helvetica;
      font-weight: 400;
      color: #8590AC;
      line-height: 27px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/helpCenter.vue